<template>
  <el-container>
    <el-aside id="sidebar">
<!--      $route.fullPath-->
      <el-menu :default-active="$route.fullPath" unique-opened router
               background-color="#ffffff"
               text-color="#161616" active-text-color="#fdc558">
        <el-menu-item :index="'/desc?projectId=' + projectId"><i class="iconfont icon-xiangqing"></i>
          <span>项目详情</span>
        </el-menu-item>
        <el-menu-item :index="'/simpleFile?projectId=' + projectId"><i class="iconfont icon-yangben"></i>
          <span>样本管理</span>
        </el-menu-item>
        <el-menu-item :index="'/groupFile?projectId=' + projectId"><i class="iconfont icon-fenzu"></i>
          <span>分组管理</span>
        </el-menu-item>
        <el-menu-item :index="'/addAnalyze?projectId=' + projectId"><i class="iconfont icon-ziliao"></i>
          <span>新建分析</span>
        </el-menu-item>
        <el-menu-item :index="'/analyze?projectId=' + projectId"><i class="iconfont icon-fenxiguanli"></i>
          <span>分析管理</span>
        </el-menu-item>
<!--        <el-menu-item :index="'/rawData?projectId=' + projectId"><i class="iconfont icon-fenxi"></i>-->
<!--          <span>原始数据</span>-->
<!--        </el-menu-item>-->
      </el-menu>
    </el-aside>
    <el-main class="m-content-display">
      <div class="m-router-view">
        <transition name="nodebook" mode="out-in">
          <router-view/>
        </transition>
      </div>
      <el-footer style="margin-bottom: 0px;height: 20px">
        <Footers></Footers>
      </el-footer>
    </el-main>
  </el-container>
</template>

<script>
import Footers from "@/components/Footers";

export default {
  name: 'projectIndex',
  components: {Footers},
  data() {
    return {
      projectId: '',

    }
  },
  created() {
    this.projectId = this.$route.query.projectId
    var projectAll = this.$store.getters['right/getUser']
    if (!this.projectId && projectAll && projectAll.projectsRow) {
      this.projectId = projectAll.projectsRow.projectId
    }
    // console.log(this.$store.getters['right/getRole'])
  },
  mounted() {

  },
}
</script>

<style scoped>
#sidebar {
  background-color: #fdfdfe;
}

#sidebar .el-menu .el-submenu li {
  background-color: #fdfdfe !important;
}

#sidebar .el-menu .el-submenu li:hover {
  background-color: #fdfdfe !important;
}
/*/deep/.is-active{*/
/*  background-color: #fdf5e2 !important;*/
/*}*/
::v-deep.el-menu-item:hover,::v-deep.el-menu-item:focus{
  background-color: #fdf5e2 !important;
}
::v-deep.el-submenu__title:hover {
  /*color:white!important;*/
  background: #eee6d5 !important;
}
/deep/.el-submenu__title:hover {
  /*color:white!important;*/
  background: #fdf5e2!important;
}
/deep/.el-menu--inline li {
  /*color:white!important;*/
  background: #f6f7f8 !important;
}
.el-header-col-right {
  display: flex;
  align-items: center;
  justify-content: end;
}

.el-dropdown {
  color: #fff;
}

.header-name {
  display: flex;
  align-items: center;
  height: 100%;
}

.el-row,
.el-col {
  height: 100%;
}


.header-name img {
  width: 40px;
  margin: 0 20px;
}

.el-header {
  background-color: #fbc446;
  color: #fff;
}


.el-aside {
  width: 230px !important;
  height: 100%;
  background-color: #fdfdfe;
}

.el-container {
  height: 100%;
}

.el-menu {
  border: 0;
}

.m-router-view {
  flex: 1;
}

.m-content-display {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
</style>
